import NepFloorplansConfig, { NepFloorPlansOptionId } from '~/tenants/nep/performable/floorplans/NepFloorplansConfig';
import NepJob from '~/tenants/nep/model/NepJob';
import { TenantOrderLine } from '~/lib/model';
import { Big } from 'big.js';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import { NepOrderType } from '~/tenants/nep/model/NepOrder';

export interface NepFloorPlansOptions {
  onsite: number; // TODO: need official numbers
  revenue: number;
  from: number;
  to: number;
}

export const DEMO_FLOORPLANS_OPTIONS: Record<NepFloorPlansOptionId, NepFloorPlansOptions> = {
  [NepFloorPlansOptionId.ONE]: {
    onsite: 10,
    revenue: 60,
    from: 0,
    to: 1000,
  },
  [NepFloorPlansOptionId.TWO]: {
    onsite: 10,
    revenue: 80,
    from: 1001,
    to: 2000,
  },
  [NepFloorPlansOptionId.THREE]: {
    onsite: 15,
    revenue: 100,
    from: 2001,
    to: 3000,
  },
  [NepFloorPlansOptionId.FOUR]: {
    onsite: 15,
    revenue: 120,
    from: 3001,
    to: 4000,
  },
  [NepFloorPlansOptionId.FIVE]: {
    onsite: 20,
    revenue: 140,
    from: 4001,
    to: 5000,
  },
  [NepFloorPlansOptionId.SIX]: {
    onsite: 20,
    revenue: 160,
    from: 5001,
    to: 6000,
  },
  [NepFloorPlansOptionId.SEVEN]: {
    onsite: 30,
    revenue: 180,
    from: 6001,
    to: 7000,
  },
  [NepFloorPlansOptionId.EIGHT]: {
    onsite: 45,
    revenue: 200,
    from: 7001,
    to: 8000,
  },
};

export default class NepFloorplansJob extends NepJob<typeof NepFloorplansConfig> {
  get performable() {
    return NepFloorplansConfig;
  }

  onsite(): number {
    return DEMO_FLOORPLANS_OPTIONS[this.metadata.option].onsite;
  }

  defaultValue(): ZodVersionedMetadata<(typeof NepFloorplansConfig)['schema']> {
    let option: undefined | NepFloorPlansOptionId = undefined;

    for (const [key, value] of Object.entries(DEMO_FLOORPLANS_OPTIONS)) {
      if (this.order.metadata.sqft >= value.from && this.order.metadata.sqft <= value.to) {
        // TODO: better typing
        option = key as any as NepFloorPlansOptionId;
        break;
      }
    }

    if (!option) {
      throw new Error('No option found for sqft range');
    }

    return {
      option,
      version: schema_latest_version(NepFloorplansConfig.schema),
    };
  }

  get configurable() {
    return false;
  }

  get multiple() {
    return this.order.metadata.type !== NepOrderType.COMMERCIAL;
  }

  get hourly() {
    return this.order.metadata.type === NepOrderType.COMMERCIAL;
  }

  revenueLines(): TenantOrderLine[] {
    if (this.order.metadata.type === NepOrderType.COMMERCIAL) {
      return [];
    }

    const option = DEMO_FLOORPLANS_OPTIONS[this.metadata.option];

    const amount = new Big(option.revenue);

    return [
      {
        amount,
        description: this.performable.name,
        id: this.performable.id,
        discountable: true,
      },
    ];
  }
}
